import Component from '../core/Component';
import support from '../utils/BrowserSupport'
import ScrollContainer from './ScrollContainer'
import EventBus from '../core/EventBus';
import { CMS } from '../core/config'
import keycode from 'keycode'

export const STATES = {
    VISIBLE: 'is-visible',
    ACTIVE: 'is-active'
}

export default class BookingSidebar extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            scrollContainer: null,
            toggle: null
        }

        this.scrollContainer = new ScrollContainer(this.ref.scrollContainer)

        if (this.scrollContainer) {
            this.scrollContainer.prepare()

            if (this.scrollContainer.scrollbar) {
                this.scrollContainer.scrollbar.scrollTo(0,0)
            }
        }
    }

    prepare() {
        if (!CMS) {
            this.ref.toggle.addEventListener('click', this.handleClick)
        }

        this.element.addEventListener(support.transitionEnd, event => {
            if (event.target === this.element && !this.is(STATES.ACTIVE)) {
                this.element.classList.remove(STATES.VISIBLE)
            }
        })

        document.addEventListener('click', this.handleOuterClick)
    }

    destroy() {
        document.removeEventListener('keydown', this.handleKeyDown)
    }

    handleOuterClick = (event) => {
        // Close on click outside
        if (!this.ref.scrollContainer.contains(event.target) && !event.target.closest('button')) {
            this.close()
        }

        // Close on click on link to other page
        if (event.target.href) {
            if (event.target.href.replace(window.location.origin, '').indexOf('/') != -1 && event.target.getAttribute('target') != '_blank') {
                this.close()
            }
        }
    }

    handleClick(event) {
        event.preventDefault()
        this.close()
    }

    handleKeyDown = (event) => {
        if (keycode(event.keyCode) === 'esc') {
            this.close()
        }
    }

    close() {
        if (!this.is(STATES.ACTIVE)) {
            return
        }

        this.element.classList.remove(STATES.ACTIVE)
        this.emit('close')

        document.removeEventListener('keydown', this.handleKeyDown)

        EventBus.emit('fullmodal:close', {
            id: this.element.id
        })
    }

    open() {
        this.element.classList.add(STATES.VISIBLE)
        this.element.offsetWidth
        this.element.classList.add(STATES.ACTIVE)
        this.emit('open')

        document.addEventListener('keydown', this.handleKeyDown)

        EventBus.emit('fullmodal:open', {
            id: this.element.id
        })
    }

    toggle() {
        if (this.is(STATES.ACTIVE)) {
            this.close()
        } else {
            this.open()
        }
    }

    handleClick = event => {
        event.preventDefault()

        this.toggle()
    }
}